import * as React from 'react';
import {Platform, StatusBar, StatusBarProps} from 'react-native';
import {useIsFocused} from '@react-navigation/native';

export function AndroidStatusBar(props: StatusBarProps) {
  const isFocused = useIsFocused();
  if (Platform.OS === 'ios') return null;
  return isFocused ? <StatusBar {...props} /> : null;
}
